import script from "./Sponsors.vue?vue&type=script&setup=true&lang=js"
export * from "./Sponsors.vue?vue&type=script&setup=true&lang=js"

import "./Sponsors.vue?vue&type=style&index=0&id=300213d1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300213d1"]])

export default __exports__